module.exports = __webpack_public_path__ + "static/media/1a.af0d49c0.jpg";